<ng-container *ngIf="question">
  <ng-container [ngSwitch]="question.field_type">
    <!-- TEXT FIELD -->
    <ng-container *ngSwitchCase="FieldTypes.TEXT">
      <ng-container *ngIf="viewState === viewStates.PREVIEW; else textInput">
        <div class="placeholder-text-input">
          <div class="handle"></div>
        </div>
      </ng-container>
      <ng-template #textInput>
        <input
          type="text"
          class="proforms-text-input"
          [formControl]="textControl" />
      </ng-template>
    </ng-container>

    <!-- TEXTAREA FIELD -->
    <ng-container *ngSwitchCase="FieldTypes.TEXTAREA">
      <ng-container
        *ngIf="viewState === viewStates.PREVIEW; else textareaInput">
        <div class="placeholder-textarea">
          <div class="handle"></div>
        </div>
      </ng-container>
      <ng-template #textareaInput>
        <textarea
          class="proforms-text-input proforms-text-input-textarea"
          [formControl]="textareaControl">
        </textarea>
        <ng-container *ngIf="isObservationSession">
          <ng-container
            *ngIf="!smartResponsePreview; else smartResponsePreviewTpl">
            <ng-container *ngIf="smartResponseError">
              <div
                class="alert alert-danger text-start mt-2 alert-dismissible"
                role="alert">
                {{ smartResponseError }}
                <button
                  type="button"
                  class="btn-close"
                  (click)="smartResponseError = null"
                  aria-label="Close"></button>
              </div>
            </ng-container>
            <button
              ngbTooltip="Generate a smart response based on your current answers"
              placement="right"
              class="btn btn-ai btn-sm fw-800 mt-2"
              [class.loading]="smartResponseLoading"
              [disabled]="smartResponseLoading"
              (click)="generateSmartResponse()">
              <div class="loading-stars">
                <img src="/assets/star-lg.svg" class="star-lg" alt="" />
                <img src="/assets/star-sm.svg" class="star-sm" alt="" />
              </div>
              <img src="/assets/ai-stars.svg" class="ai-stars" alt="AI Stars" />
              <ng-container *ngIf="smartResponseLoading; else smartBtnLabel">
                Generating<span class="ellipsis-anim ms-1"
                  ><span>.</span><span>.</span><span>.</span></span
                >
              </ng-container>
              <ng-template #smartBtnLabel>Smart Response</ng-template>
            </button>
          </ng-container>
          <ng-template #smartResponsePreviewTpl>
            <div class="smart-response-preview mt-2">
              <div class="smart-response-preview__header">
                <img src="/assets/ai-stars-pink.svg" alt="AI Stars" />
                <span class="fw-800 ms-1">Smart Response</span>
                <button
                  class="smart-response-preview__dismiss"
                  (click)="dismissSmartResponse()">
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div
                class="smart-response-preview__body"
                [textContent]="smartResponsePreview"></div>
              <div class="smart-response-preview__actions">
                <button
                  class="btn btn-primary btn-sm fw-800"
                  (click)="acceptSmartResponse()">
                  Use this
                </button>
                <button
                  class="btn btn-ai btn-sm fw-800"
                  [class.loading]="smartResponseLoading"
                  [disabled]="smartResponseLoading"
                  (click)="generateSmartResponse()">
                  <div class="loading-stars">
                    <img src="/assets/star-lg.svg" class="star-lg" alt="" />
                    <img src="/assets/star-sm.svg" class="star-sm" alt="" />
                  </div>
                  <img
                    src="/assets/ai-stars.svg"
                    class="ai-stars"
                    alt="AI Stars" />
                  <ng-container *ngIf="smartResponseLoading; else regenLabel">
                    Generating<span class="ellipsis-anim ms-1"
                      ><span>.</span><span>.</span><span>.</span></span
                    >
                  </ng-container>
                  <ng-template #regenLabel>Regenerate</ng-template>
                </button>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
